//export const api = 'https://movietime.wemonde.com/api/';
// export const api = 'https://pvrnewapi.wemonde.in/api/';
export const admin = "https://wowcms.wemonde.com/admin/";
export const api = "https://cms.wowcinemas.om/api/";
export const av = "1.3";
export const pt = "WEBSITE";
export const did = "1234567768";
export const country = "INDIA";
export const dp = "";